import { DialogActions, DialogContent, DialogTitle, Stack, Switch, Grid } from '@mui/material';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { CrmJobStatusDTO, saveCrmJobStatus } from 'wisestep-api';
import { ControlledTextInput, Label, WsButton, WsDialog } from 'wisestep-base';

import WsCheckBox from '../../../../components/WsCheckBox/WsCheckBox';
import { success, failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

const crmJobStatusExtraFormDefaults = {
  isDefaultStatus: false,
  isInactive: false,
  visibility: true,
};

const CrmJobStatusForm = ({
  open,
  onSave,
  onCancel,
  defaultValues,
  crmJobStatusList,
}: {
  open: boolean;
  onSave: () => void;
  onCancel: () => void;
  defaultValues?: CrmJobStatusDTO;
  crmJobStatusList?: CrmJobStatusDTO[];
}) => {
  const form = useForm({ defaultValues: { ...crmJobStatusExtraFormDefaults, ...defaultValues } });
  const setNotification = useNotificationStore((state) => state.setNotification);

  const onSubmit = async (data: Partial<CrmJobStatusDTO>) => {
    try {
      const hasMultipleDefaultStatus =
        Array.isArray(crmJobStatusList) &&
        crmJobStatusList.filter((item) => item.isDefaultStatus).length == 1;

      if (hasMultipleDefaultStatus && data.isDefaultStatus) {
        setNotification(failed('Cannot set more than one default status.'));
      } else {
        await saveCrmJobStatus(data as CrmJobStatusDTO);
        setNotification(success('CRM Job status has been saved successfully !!'));
        onSave();
      }
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(failed(`CRM Job Status with name ${data.statusName} already exists!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  return (
    <WsDialog openDialog={open} onClose={onCancel}>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <DialogTitle>Add/Edit CRM Job Status</DialogTitle>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={10}>
                <ControlledTextInput
                  name="statusName"
                  labelText="CRM Job Status Name"
                  size="medium"
                  required
                  fullWidth={true}
                />
              </Grid>
              <Grid item xs={5}>
                <WsCheckBox name="isDefaultStatus" label="Make Default Status" />
              </Grid>
              <Grid item xs={6}>
                <WsCheckBox name="isInactive" label="Make Inactive" />
              </Grid>
              <Grid item xs={12}>
                <Controller
                  name="visibility"
                  control={form.control}
                  render={({ field: { onChange, value } }) => (
                    <Stack direction="row" spacing={1} alignItems="baseline">
                      <Label>Visibility</Label>
                      <Switch checked={value} onChange={onChange} />
                    </Stack>
                  )}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <WsButton onClick={onCancel}>Cancel</WsButton>
            <WsButton type="submit">Save</WsButton>
          </DialogActions>
        </form>
      </FormProvider>
    </WsDialog>
  );
};

export default CrmJobStatusForm;
